<!--会员卡兑换-->
<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">会员卡兑换</span>
    </mu-appbar>
    <br />
    <div class="bigpage">
      <div align="left">
        <!--<mu-divider class="dividerClass"/>-->
        <mu-text-field hintText="请输入手机号" type="text" icon="smartphone" v-model="UserPhone" style="margin-left:-4% ; width:103% " />
        <mu-text-field hintText="请输入真实姓名" type="text" icon="person " v-model="RealName" style="margin-left:-4% ; width:103% " />
        <mu-text-field hintText="请输入邮箱(选填)" type="text" icon="email " v-model="UserEmail" style="margin-left:-4% ; width:103% " />
        <mu-text-field hintText="请设置您的密码" type="password" icon="lock" v-model="UserPass" style="margin-left:-4% ; width:103% " />
        <mu-text-field hintText="请输入8位兑换码" type="text" icon="verified_user" v-model="CardCode" style="margin-left:-4% ; width:103% " />
        <nobr>
          <!--图片附加码-->
          <mu-text-field hintText="请输入附加码" type="text" icon="vpn_key" v-model="FJM" class="txtValidate" style="margin-left:-4% ; width:72% " />
          <img v-bind:src="this.TPFJM" style="width:27% ; margin-left:2% ; margin-bottom:-2%" v-on:click="this.getValidateCode" />
        </nobr>
      </div>
      <mu-raised-button label="兑 换" primary="" @click="cardExchange" v-bind:style="{ width:'100%',height:'0.8rem' }" style="font-size:0.3rem ; margin-top : 0.5rem" />
      <br />
      <br />
      <br />
      <br />
    </div>
    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
    <br />
    <br />
    <br />
    <mu-dialog dialogClass="dialog-cardno" :title="dialogTitle" :open="showDialog">
      <mu-flexbox orient="vertical">
        <mu-flexbox-item>
          <mu-card-text style="font-size:16px;font-weight:700;text-align: center;">会员卡兑换成功！</mu-card-text>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <mu-card-text>卡号：{{CardNo}}</mu-card-text>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <mu-card-text>类型：{{CardKind}}</mu-card-text>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <mu-raised-button label="我知道了" @click="goLogin" v-bind:style="{ width:'100%',height:'0.8rem' }" style="font-size:0.3rem ; margin-top : 0.5rem" primary/>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <mu-card-text>{{NewInfo}}</mu-card-text>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'

export default {
  data() {
    return {
      //  输入框初始化
      UserPhone: '',
      RealName: '',
      UserEmail: '',
      UserPass: '',
      CardCode: '',
      FJM: '', //附加码
      TPFJM: '', //图片附加码
      // 弹出层 弹出内容
      toast: false,

      //兑换成功提示
      showDialog: false,
      dialogTitle: '',
      CardNo: '',
      CardKind: '',
      NewInfo: '',
      TimeOut: 0
    }
  },
  //进入时运作
  activated() {
    this.UserPhone = ''
    this.RealName = ''
    this.UserEmail = ''
    this.UserPass = ''
    this.CardCode = ''
    this.FJM = ''
    this.TimeOut = 1500
    this.getValidateCode()
  },
  methods: {
    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getValidateCode()
    },
    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toast = false
      }, this.TimeOut)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    //会员卡兑换
    cardExchange() {
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ //验证邮箱
      var regNumber = /\d+/ //验证0-9的任意数字最少出现1次。
      var regString = /[a-zA-Z]+/ //验证大小写26个字母任意字母最少出现1次。
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
        return
      } else if (this.UserPhone.length != 11) {
        this.TellUser = '手机号格式不正确'
        this.showToast()
        return
      } else if (this.RealName == '') {
        this.TellUser = '请输入您的真实姓名'
        this.showToast()
        return
      } else if (this.UserEmail.length > 0 && !regEmail.test(this.UserEmail)) {
        this.TellUser = '请输入正确的邮箱地址'
        this.showToast()
        return
      } else if (this.UserPass == '') {
        this.TellUser = '请输入您的密码'
        this.showToast()
        return
      } else if (this.UserPass.length < 6) {
        this.TellUser = '密码不能小于6位'
        this.showToast()
        return
      } else if (this.UserPass.length > 15) {
        this.TellUser = '密码不能大于15位'
        this.showToast()
        return
      } else if (
        regNumber.test(this.UserPass) == false ||
        regString.test(this.UserPass) == false
      ) {
        this.TellUser = '密码需要同时包含数字和字母'
        this.showToast()
        return
      } else if (this.CardCode == '' || this.CardCode.length != 8) {
        this.TellUser = '请输入8位兑换卡号'
        this.showToast()
        return
      } else if (this.FJM == '') {
        this.TellUser = '请输入验证码'
        this.showToast()
        return
      } else if (this.FJM.length != 4) {
        this.TellUser = '验证码格式不正确'
        this.showToast()
        return
      }

      var params = new this.URLSearchParam()
      params.append('userPhone', this.UserPhone)
      params.append('realName', this.RealName)
      params.append('userEmail', this.UserEmail)
      params.append('userPass', this.UserPass)
      params.append('cardCode', this.CardCode)
      params.append('validateCode', this.FJM)
      //  快捷登录
      this.$http.post(api.postCreateCard(), params.toParam()).then(res => {
        if (res.Result) {
          this.CardNo = res.Data.CardNo
          this.CardKind = res.Data.CardKind
          this.NewInfo = res.Data.NewInfo
          this.showDialog = true
        } else {
          this.TimeOut = 5000
          this.TellUser = res.Message
          this.showToast()
          this.FJM = ''
          this.getValidateCode()
        }
      })
    },
    goLogin() {
      this.showDialog = false
      this.$router.push({ path: '/user/Login' })
    }
  }
}
</script>
<style lang="less" scoped="">
@import '../../../assets/theme.less'; // 顶部标签变换
.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  .bigpage {
    width: 80%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor;
  }

  .Black {
    color: @primaryBlack;
  }

  .Grey {
    color: @textColor;
  }
}
</style>
<style lang="less">
.dialog-cardno {
  .mu-dialog-title {
    color: rgb(102, 102, 102);
    padding: 0.12rem 0.16rem 0.12rem; //12px 16px 12px;
    font-size: 0.32rem; //18px;
  }
  .mu-card-text {
    padding: 0.02rem 0 0.03rem 0.06rem; //2px 0 3px 6px;
  }
}
</style>




// WEBPACK FOOTER //
// CreateCard.vue?5ee817ce